export const hideFrameStyles = {
    opacity: '0',
    visibility: 'hidden',
    transition: '.2s opacity',
}

export const showFrameStyles = {
    opacity: '1',
    visibility: 'visible',
    transition: '.2s opacity',
}
